export enum OmniMessageType {
    NOTIFY_TAB = 'NT',
    SHUTTING_DOWN_ENGAGEMENT = 'SHDOE',
    STARTING_ENGAGEMENT = 'STAE'
}
  
export interface OmniMessage { 
    type: OmniMessageType, 
    tab: string


}

export interface OmniPageContextType {
    engagementIsValid: () => boolean
    setTabEngagement: ()=> void
    removeTabEngagement: ()=> void
    isTabActive: ()=>boolean
  }
  
export type BrowserEngagementStatus = {
    active: boolean,
    id: string, 
    updated: Date
}